export enum PaperSizeEnum {
  Paper_100_70 = "100x70",
}

export const PaperSizeOptions = [
  {
    value: PaperSizeEnum.Paper_100_70,
    label: PaperSizeEnum.Paper_100_70 + " mm",
  }
];
